import React, { useContext, useState } from 'react';
import NavPageLink from './NavPageLink';
import { SidebarContext } from './SidebarContext';

interface NavSubsectionProps {
  iconName: string;
  iconSrc?: string;
  linkDisplayText: string;
  children: React.ReactNode;
}

const NavSubsection = ({ iconName, iconSrc, linkDisplayText, children }: NavSubsectionProps) => {
  const { isCollapsed, toggleSidebar } = useContext(SidebarContext);
  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    if (isCollapsed) {
      toggleSidebar();
      setExpanded(true);
      return;
    }
    setExpanded(prev => !prev);
  };

  return (
    <li className="nav-item">
      <button
        type="button"
        className={`nav-link btn btn-link text-start w-100 ${isCollapsed ? 'px-0 justify-content-center' : 'px-3 d-flex align-items-center'}`}
        onClick={handleClick}
        title={isCollapsed ? linkDisplayText : undefined}
        aria-label={linkDisplayText}
        aria-expanded={expanded}>
        {iconSrc
          ? <span className="nav-icon d-inline-flex align-items-center justify-content-start"><img src={iconSrc} alt="" width={16} height={16} /></span>
          : <i className={`bi-${iconName} nav-icon`}></i>}
        {!isCollapsed && <span className="flex-grow-1">{linkDisplayText}</span>}
        {!isCollapsed && <i className={`bi-chevron-${expanded ? 'down' : 'right'} ms-auto`}></i>}
      </button>
      {!isCollapsed &&
        <ul className={`nav nav-vertical ms-3 collapse${expanded ? ' show' : ''}`}>
          {children}
        </ul>}
    </li>
  );
};

interface FieldAlyticsNavSubsectionProps {
  routePrefix: string;
}

const FieldAlyticsNavSubsection = ({ routePrefix }: FieldAlyticsNavSubsectionProps) => (
  <NavSubsection iconName="grid" iconSrc="/FieldAlytics_Icon.png" linkDisplayText="FieldAlytics">
    <NavPageLink defaultPath={`${routePrefix}/fieldalytics/settings`} iconName="gear" linkDisplayText="Settings" />
    <NavPageLink defaultPath={`${routePrefix}/fieldalytics/siteMapping`} iconName="geo-alt" linkDisplayText="Site Mapping" />
    <NavPageLink defaultPath={`${routePrefix}/fieldalytics/productMapping`} iconName="diagram-3" linkDisplayText="Product Mapping" />
    <NavPageLink defaultPath={`${routePrefix}/fieldalytics/orders`} iconName="file-ruled" linkDisplayText="Orders" />
  </NavSubsection>
);

interface IntegrationNavSubsectionsProps {
  routePrefix: string;
  integrations: string[];
}

export const IntegrationNavSubsections = ({ routePrefix, integrations }: IntegrationNavSubsectionsProps) => (
  <>
    {integrations.includes('FieldAlytics') && <FieldAlyticsNavSubsection routePrefix={routePrefix} />}
  </>
);
